import { useEffect, useRef } from "react";
import { DefaultRootState, useSelector } from "react-redux"; 

export function useSelectorWithDebounced<TState = DefaultRootState, TSelected = unknown>(
    selector: (state: TState) => TSelected,
    debounce: number = 1000,
    equalityFn?: (left?: TSelected, right?: TSelected) => boolean,
): TSelected {
    const refData = useRef<TSelected>();
    const refIsAwait = useRef<boolean>(false);
    const timeoutRef = useRef(null);

    useEffect(() => {
        return () => {
            clearTimeout(timeoutRef.current);
        };
    }, []);

    return useSelector<TState,TSelected>((state) => {
        if (refIsAwait.current) {
            return refData.current as TSelected;
        }
        refData.current = selector(state);
        refIsAwait.current = true;
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => { refIsAwait.current = false }, debounce);
        return refData.current;
    }, equalityFn);
}